<template>
  <div class="card">
    <h5 class="card-header">Interview</h5>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="border-top-0">Name</th>
            <th scope="col" class="border-top-0">Attributes</th>
            <th class="text-center border-top-0 enabled-header">
              Enabled
              <span data-toggle="tooltip" data-placement="top" title="This enables or disables the user from using this interview.">
                <fa icon="question-circle" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr colspan="12" v-if="!items.length" class="text-muted text-center">
            <td colspan="12">
              No interviews
            </td>
          </tr>
          <tr v-for="item in items" :key="item.id">
            <td>
              <span class="pt-2" :class="item.status !== 'enabled' ? 'text-muted' : ''">{{ item.displayName }}</span>
            </td>
            <td>
              <button class="btn btn-sm btn-link px-0" @click="viewAttributes(item)">
                View Attributes
              </button>
            </td>
            <td class="text-center">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="item.id"
                  :disabled="loadingMessage"
                  :checked="item.status === 'enabled'"
                  @change="toggle(item, $event)"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Modal (View) -->
    <div ref="modalView" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header border-0">
            <h5 class="modal-title text-capitalize">Interview Attributes</h5>
            <button type="button" class="close" aria-label="Close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <ViewUserInterviewAttributes :organizationId="organizationId" :interviewId="modalViewInterviewId" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ViewUserInterviewAttributes from "@/views/reports/users/ViewUserInterviewAttributes.vue";

export default {
  components: {
    ViewUserInterviewAttributes,
  },
  props: {
    organizationId: String,
    userId: String,
  },
  data() {
    return {
      loadingMessage: null,
      error: null,

      items: [],
      modalViewInterviewId: null,
    };
  },
  created() {
    this.load();
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ boundary: "window" });
  },
  watch: {
    organizationId() {
      this.load();
    },
    userId() {
      this.load();
    },
  },
  methods: {
    load() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/users/${this.userId}/interviews`)
        .then(res => (this.items = res.data))
        .catch(() => this.$router.push(`/organizations/${this.organizationId}/users/${this.userId}`))
        .finally(() => (this.loadingMessage = null));
    },
    toggle(item, $event) {
      const payload = {
        status: $event.target.checked ? "enabled" : "disabled",
      };

      this.loadingMessage = "Saving...";
      this.$axios
        .put(`/v1/organizations/${this.organizationId}/users/${this.userId}/interviews/${item.id}`, payload)
        .then(() => this.load())
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
    viewAttributes(interview) {
      this.modalViewInterviewId = interview.id;
      $(this.$refs.modalView).modal("show");
    },
  },
};
</script>

<style lang="scss" scoped>
.table-responsive {
  height: 400px;
  overflow-y: scroll;

  table {
    margin-bottom: 0;

    thead tr:nth-child(1) th {
      background: white;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .enabled-header {
      width: 115px;
    }
  }
}

.custom-control-label {
  cursor: pointer;
}
</style>
